import React from "react";
// import Wrp from "../../../hoc/Wrp/Wrp";
import { isSet } from "../../../Utils/CommonFunctions";
import { withRouter } from 'react-router';
import { useSelector } from "react-redux";
import { clearGoBackURL, getGoBackURL } from "../../../Utils/UserFunctions";
import { extractFieldValue, getDataScmAttributes } from "../MarkupFunctions";

// import { getOutputFieldsElement,isValidJson } from "../MarkupFunctions";

// Module-level: track which actions already triggered onload (shared across all ScmButton instances to avoid duplicate API calls)
const onloadRequestedActions = new Set();

const ScmButton = ({ attributes, elmtParams,...props })=>{
    const pageFlows = useSelector((state) =>state.PagesReducer.pageFlows);
    const {convertAndRenderElement} = elmtParams;
    const {loopData,children,defProps,childActionButtons,dynamicVar} = elmtParams;
    // console.log('attributes',attributes);
    const {name,label,type,action,fields} = attributes;
    const {actionButtons,dynamicSystemHandler,onSubmitShipNow} = defProps;
    
    // Check if action references a button object from dynamicVar (e.g., "pkg.actions.Clone" or "Package.bulkActions.BulkEdit")
    let buttonObject = null;
    let buttonClickHandler = null;
    let buttonAttributes = {};
    // let shouldShowButton = true;
    
    if (action && dynamicVar) {
      // Extract the button object from dynamicVar using the action path
      buttonObject = extractFieldValue(dynamicVar, action);
      if (buttonObject && typeof buttonObject === 'object') {
        // Check access_mode - if false, don't show the button
        // if (buttonObject.access_mode === false) {
        //   shouldShowButton = false;
        // }
        // Extract clickHandler and attributes from the button object
        // if (buttonObject.clickHandler) {
        //   buttonClickHandler = buttonObject.clickHandler;
        // }
        buttonAttributes ={...buttonObject}
        // console.log('buttonAttributes',buttonAttributes);
        // if (buttonObject.attributes) {
        //   buttonAttributes = buttonObject.attributes;
        // }
      }
    }
    
    // If button should not be shown (access_mode is false), return null
    // if (!shouldShowButton) {
    //   return null;
    // }
    
    // console.log('paramObj',attributes,defProps);
    const {isExist,isCustom,data} = findActionButtons(childActionButtons,actionButtons,name);
    // console.log('isExist',isExist,isCustom,name,data,actionButtons);
    if(isExist===true && name.toLowerCase()=='ship now'){
      return React.createElement('a', {...attributes,onClick:()=>onSubmitShipNow({},false,{selected_rate:loopData,btnOption:data})},isSet(label,name));  
    }else if(isExist===true && isCustom===true && isSet(data.clickHandler,null)!==null){
      return React.createElement('a', {...attributes,onClick:data.clickHandler},name); 
    }else if(isExist===true){
       return React.createElement('a', {...attributes,onClick:()=>dynamicSystemHandler({},false,{selected_rate:loopData,btnOption:data})},isSet(label,name));   
    } else{
      let clickHandlerMethod = ()=>{};
      
      // If we have a button click handler from dynamicVar, use it
      if (buttonClickHandler) {
        clickHandlerMethod = buttonClickHandler;
      } else if(type==="clear"){
        clickHandlerMethod = ()=>clearButtonHandlers(fields,defProps)
      }else if(type=='back'){
        const lastPage = pageFlows?.history?.at(-1);
        //  clickHandlerMethod = ()=>defProps.goToHistoryPageAction('',lastPage);
        clickHandlerMethod = () => {
          const curPage = defProps.match.params.configKey;

          // If separate window, stop
          if (pageFlows.pageData[curPage]?.pages?.display_type !== "SAME_WINDOW") return;

          // If lastPage exists, navigate there
          if (lastPage) {
            defProps.goToHistoryPageAction('', lastPage);
            defProps.history.push(`/pages/${lastPage}`);
            return;
          }

          // Use stored go-back URL, else browser goBack
          const firstUrl = getGoBackURL?.()?.[0];
          firstUrl ? defProps.history.push(firstUrl) : defProps.history.goBack();

          clearGoBackURL();
        };

// }

      }
      if(type==='page'){
        const dataScmAttrs = getDataScmAttributes(attributes,extractFieldValue,dynamicVar);
        const pageDataEmpty = Object.keys(isSet(pageFlows?.pageData?.[action], {})).length === 0;
        const notYetRequested = !onloadRequestedActions.has(action);
        if (notYetRequested) {
          onloadRequestedActions.add(action);
          defProps?.loadPagesConfigAction('API_NAME', action, { history: props?.history, onload: true, params: dataScmAttrs });
        }
        if (!pageDataEmpty) {
          if(pageFlows?.pageData[action]?.config_type==="AUTOMATION"){
            clickHandlerMethod = ()=>defProps?.onSubmitAutomationHandler(action,dataScmAttrs);
          }else{
            clickHandlerMethod = ()=>defProps?.loadPagesConfigAction('API_NAME', action, { history: props?.history, onload: false, params: dataScmAttrs });
          }
        }
      }
      // Merge button attributes from dynamicVar if they exist
      const finalAttributes = Object.keys(buttonAttributes).length > 0 
        ? { ...attributes,onClick:clickHandlerMethod, ...buttonAttributes }
        : { ...attributes,onClick:clickHandlerMethod };
      // console.log('finalAttributes',children);
      if(children.length===0){
        return React.createElement('a', {...finalAttributes},isSet(label,name));
      }else{
        return React.createElement('a', {...finalAttributes}, convertAndRenderElement(children,elmtParams));
      }
    }   
    
}

  const clearButtonHandlers = (fields,defProps)=>{
    const fieldsInSplits = fields.split(',');
    const {fieldGroups,onBlurAfterChange} = defProps;
    let assignValuesInArray = [];
    let fieldsInArr = [];
    isSet(fieldsInSplits,[]).forEach((variableValue)=>{
      let fieldName = variableValue.replace(/{/gi,'');
      fieldName = fieldName.replace('$','');
      fieldName = fieldName.replace(/}/gi,'');
      fieldsInArr.push(fieldName.toLowerCase());
    });
    
    fieldGroups.forEach((section,sectionIndex) => {
      if(section.type!=='subform'){
          section.data.forEach((field,fieldIndex)=>{
              if(fieldsInArr.indexOf(field.label.blocks[0].text.toLowerCase())!==-1){ 
                const obj = {
                  key:{type:'SECTION',section:section,sectionIndex:sectionIndex,fieldIndex:fieldIndex,modType:defProps.modType},
                  value:''
                }
                assignValuesInArray.push(obj);
              }
          }) 
      }
    });
    onBlurAfterChange({valuesInArr:assignValuesInArray,modType:defProps.modType,isBulk:true},'');
  }

  const findActionButtons = (obj,otherActions=[],buttonName)=>{
    let returnData = {isExist:false,data:{}};
    Object.entries(obj).map(([key,val])=>{
      val.map((item)=>{
        if(item.name.toLowerCase()===buttonName.toLowerCase()){
          returnData = {
            isExist:true,
            data:item
          }
        }
      })
    });
    // console.log('otherActions',otherActions,buttonName); 
    const indexing = isSet(otherActions,[]).findIndex((i=>isSet(i.name,isSet(i.component_name,'')).toLowerCase()===isSet(buttonName,'').toLowerCase()));
    // console.log('indexingindexing',indexing,otherActions);
    
    if(indexing!==-1){
      const matchedAction = otherActions[indexing];
      if (isSet(matchedAction.access_mode, true) === false) {
        return returnData;
      }
      returnData = {
        isExist:true,
        isCustom:true,
        data:{
          data:isSet(matchedAction['action_component'],{}),
          ...matchedAction,
        }
      }
    }
    return returnData;
  }
ScmButton.defaultProps = {
    attributes:{},
    elmtParams:{}
}
export default withRouter(ScmButton);